<template>
  <el-config-provider :locale="zhCn">
    <router-view />
  </el-config-provider>
</template>

<script setup lang="ts">
import { ElConfigProvider } from 'element-plus';
import zhCn from 'element-plus/es/locale/lang/zh-cn';
import { onMounted, watch } from 'vue';
import { ajax } from '@/api';
import { useAuthStore } from '@/store/auth';
import { useThemeStore } from './store/theme';

const theme = useThemeStore();
theme.initTheme();

const authStore = useAuthStore();
const pendingVisitKeys = new Set<string>();

const todayKey = () => {
  const now = new Date();
  const year = now.getFullYear();
  const month = String(now.getMonth() + 1).padStart(2, '0');
  const day = String(now.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
};

const getVisitStorageKey = () => {
  const loginKey = sessionStorage.getItem('loginKey') || authStore.loginKey || '';
  if (!loginKey) {
    return 'houShiVisit:last:guest';
  }
  const userId = sessionStorage.getItem('userId') || 'current';
  return `houShiVisit:last:user:${userId}`;
};

const recordVisitIfNeeded = () => {
  const storageKey = getVisitStorageKey();
  const today = todayKey();
  if (localStorage.getItem(storageKey) === today || pendingVisitKeys.has(storageKey)) {
    return;
  }
  pendingVisitKeys.add(storageKey);
  ajax({
    url: 'visit/record',
    method: 'POST',
    data: {
      path: `${window.location.pathname}${window.location.search || ''}${window.location.hash || ''}`
    },
    isLoading: false,
    success: (res: any) => {
      pendingVisitKeys.delete(storageKey);
      if (res?.code === 0) {
        localStorage.setItem(storageKey, today);
      }
    },
    error: (err: any) => {
      pendingVisitKeys.delete(storageKey);
      console.warn('visit record failed', err);
    }
  });
};

onMounted(recordVisitIfNeeded);

watch(
  () => authStore.loginKey,
  (loginKey, oldLoginKey) => {
    if (loginKey && loginKey !== oldLoginKey) {
      window.setTimeout(recordVisitIfNeeded, 0);
    }
  }
);
</script>

<style>
@import './assets/css/main.css';
</style>
